import useClipSelectDetailCardController, {
  UseClipSelectDetailCardControllerProps,
} from './useClipSelectDetailCardController';

export default useClipSelectDetailCardController;
export { UseClipSelectDetailCardControllerProps };
